import { useEffect, useState } from 'react';
import { isSSR } from '@/utils';

const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
};

export const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState({ breakpoint: '', value: 0 });

  const getBreakpoint = (width: number) => {
    if (width >= breakpoints.xl) return { breakpoint: 'xl', value: 4 };
    if (width >= breakpoints.lg) return { breakpoint: 'lg', value: 3 };
    if (width >= breakpoints.md) return { breakpoint: 'md', value: 2 };
    if (width >= breakpoints.sm) return { breakpoint: 'sm', value: 1 };
    return { breakpoint: 'xs', value: 0 };
  };

  useEffect(() => {
    if (isSSR) {
      return;
    }
    const handleResize = () => {
      setBreakpoint(getBreakpoint(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return breakpoint;
};
